<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.categoryName" clearable placeholder="类别名称"></el-input>
        <!--        <el-select v-model="queryParam.specialtyId" placeholder="状态" @change="getPage({pageNum: 1})" filterable clearable style="width:200px;margin-right:10px;margin-bottom: 10px;">-->
        <!--          <el-option v-for="(item,index) in Tool.map2arr($enums.userStatus)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>-->
        <!--        </el-select>-->
        <!--        <el-date-picker v-model="queryParam.addTime" type="datetime" format="yyyy-MM-dd HH:mm" placeholder="发布时间段"></el-date-picker>-->
        <el-button style="margin-left:10px;" @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam))" type="default">重置</el-button>
        <el-button style="margin-left:10px;" @click="edit()" type="primary">新建</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="sort" label="序号"></el-table-column>
        <el-table-column prop="categoryName" label="类别名称"></el-table-column>
        <el-table-column prop="addTime" label="创建时间">
          <template slot-scope="scope">
            {{$moment(scope.row.addTime).format('YYYY-MM-DD HH:mm')}}
          </template>
        </el-table-column>
        <el-table-column prop="topicCount" label="话题数量"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="edit(scope.row)">排序</el-button>
            <el-button size="mini" type="text" @click="editTopic(scope.row)">添加话题</el-button>
            <el-button v-if="scope.row.isHiden == 0" size="mini" type="text" style="color: #E91212;" @click="forbid(scope.row)">屏蔽</el-button>
            <el-button v-if="scope.row.isHiden == 1" size="mini" type="text" @click="unforbid(scope.row)">取消屏蔽</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog title="新建类别" v-if="editForm.show" :visible.sync="editForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :row="editForm.row" @close="getPage()"></Edit>
    </el-dialog>
    <el-dialog title="添加话题" v-if="topicForm.show" :visible.sync="topicForm.show" width="700px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <TopicEdit :row="topicForm.row" @close="getPage()"></TopicEdit>
    </el-dialog>
  </div>
</template>
<script>
import Edit from './category-edit'
import TopicEdit from './topic-edit'

export default {
  name: 'category',
  components: { Edit, TopicEdit },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: {},
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      editForm: { show: false, row: null },
      topicForm: { show: false, row: null }
    }
  },
  async created () {
    await this.getPage()
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.topicForm.show = false
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiCategory.getPageInfo(this.queryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row) {
      try {
        this.editForm.show = true
        if (row) {
          this.editForm.row = row
        } else {
          this.editForm.row = null
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async editTopic (row) {
      try {
        if (row) {
          this.topicForm.row = row
          this.topicForm.show = true
        } else {
          this.topicForm.row = null
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async forbid (item) {
      if (item) {
        await this.$HTTP.ApiCategory.setForbid(item.id)
        this.$message({ type: 'success', message: '操作成功' })
        await this.getPage()
      } else {
        this.$message({ type: 'error', message: '操作失败' })
      }
    },
    async unforbid (item) {
      if (item) {
        await this.$HTTP.ApiCategory.cancelForbid(item.id)
        this.$message({ type: 'success', message: '操作成功' })
        await this.getPage()
      } else {
        this.$message({ type: 'error', message: '操作失败' })
      }
    }
  }
}
</script>
